import { useGlobalSearchParams } from 'expo-router'

import { SettingsLayout } from '@/src/features/settings/ui/layouts/SettingsLayout'
import { useRoutes } from '@/src/general/utils/routes'

export default () => {
  const searchParams = useGlobalSearchParams()
  const { routes } = useRoutes()
  return <SettingsLayout searchParams={searchParams} fallbackRoute={routes['prayer-space']()} />
}
